import { Component, EventEmitter, Input, OnInit, Output, TemplateRef } from '@angular/core';

@Component({
  selector: 'app-data-table',
  templateUrl: './data-table.component.html',
  styleUrls: ['./data-table.component.less']
})
export class DataTableComponent{

  @Input() scrollWidth: string | null = null;
  @Input() pagination: boolean = true; 
  @Input() tableTitle: string = ''; 
  @Input() showDownload: boolean = false; 
  @Input() data: any[] = [];
  @Input() total = 0;
  @Input() pageIndex = 1;
  @Input() pageSize = 10;
  @Input() columns: { title: string; key: string; width?: string ,align?: string ,fixed?: 'left' | 'right'; 
    template?: TemplateRef<any>; }[] = [];

  @Output() pageChange = new EventEmitter<{ pageIndex: number, pageSize: number }>();
  @Output() download = new EventEmitter<void>(); // 下载事件
  downloading = false; 
  onPageChange(pageIndex: number, pageSize: number) {
    this.pageChange.emit({ pageIndex, pageSize });
  }

  async onDownload() {
    if (this.downloading) return; // 防止重复点击
    this.downloading = true;

    try {
      // 发出下载事件给父组件处理
      await this.download.emit(); // 如果父组件返回 Promise，可以 await
    } finally {
      this.downloading = false;
    }
  }

  calcTargetRebateAmount(purchaseTarget: any, rewardRatio: any): string {
    const parseToNumber = (val: any): number => {
      if (val == null || String(val).trim() === '') {
        return 0;
      }
      const strVal = String(val);
      if (strVal.includes('-')) {
        return 0;
      }
      const clean = strVal.replace(/,/g, '');
      const num = Number(clean);
      return isNaN(num) ? 0 : num;
    };
    const pt = parseToNumber(purchaseTarget);
    const rr = parseToNumber(rewardRatio);
    const result = pt * rr;
    return this.formatMoney(result.toFixed(2));
  }

  formatMoney(value: any, decimals = 2): string {
    if (value === null || value === undefined || value === '' || value === 0) {
      return '-';
    }

    const num = Number(value);
    if (isNaN(num)) {
      return String(value);
    }

    return num
      .toFixed(decimals)
      .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

}
